import React from "react";
import "./VehicleSpeedDisplayArray.css";
import VehicleRpmDisplay from "@components/VehicleDashboard/vehicleSpeedDisplay/VehicleRpmDisplay.js";
import VehicleSpeedDisplay from "@components/VehicleDashboard/vehicleSpeedDisplay/VehicleSpeedDisplay.js";

function formatSpeed(speed) {
  if (speed < 9.99999) {
    return speed.toFixed(1);
  } else {
    return speed.toFixed(0);
  }
}

export default function VehicleSpeedDisplayArray({
  linearSpeed,
  linearSpeedLimit,
  angularSpeed,
  angularSpeedLimit,
  rpm,
  fuel,
}) {
  return (
    <>
      <div className="spd">
        {/*<VehicleSpeedDisplay value={(parseFloat(formatSpeed(Math.abs(fuel))))} label="Fuel" unit="%" />*/}
        <VehicleSpeedDisplay
          value={parseFloat(formatSpeed(Math.abs(linearSpeed)))}
          denominator={linearSpeedLimit / 100.0}
          label="Linear"
          unit="km/h"
        />
        <VehicleSpeedDisplay
          value={parseFloat(formatSpeed(Math.abs(angularSpeed)))}
          denominator={angularSpeedLimit / 100.0}
          label="Angular"
          unit="rad/s"
        />
        <VehicleRpmDisplay
          value={parseFloat(formatSpeed(Math.abs(rpm)))}
          label="Engine"
          unit="r/min"
        />
      </div>
    </>
  );
}
